import axios from "axios";

const axiosInstance = axios.create({
    baseURL: 'https://video-app-sr5.herokuapp.com',
});

export default axiosInstance;